<div class="subscription-component-wrapper">
    <div
        class="education-modal-overlay"
        *ngIf="showTimeLimitedSubscriptionDialog"
    >
        <div class="education-modal" role="dialog" aria-modal="true">
            <div class="header">
                <img
                    src="assets/svg/reusable-svg/warning.svg"
                    alt="dialog-icon"
                />
                <p>
                    {{
                        'shared.components.subscriptionsPage.components.subscriptions.timeLimitedSubscriptionDialog.header'
                            | translate
                    }}
                </p>
            </div>
            <div class="question-text">
                <p
                    [innerHTML]="
                        'shared.components.subscriptionsPage.components.subscriptions.timeLimitedSubscriptionDialog.question'
                            | translate
                                : {
                                      type: currentSubscriptionType,
                                      date:
                                          currentSubscriptionEndDate
                                          | date: 'dd.MM.yyyy' : '' : 'en-En',
                                      mailToLink:
                                          '<a href=\'mailto:team@tryb.ai\'>team@tryb.ai</a>',
                                  }
                    "
                ></p>
            </div>
        </div>
    </div>
    <div class="info-wrapper">
        <span class="choose-subscription-text">
            {{
                'shared.components.subscriptionsPage.components.subscriptions.infoTexts.chooseSubscription'
                    | translate
            }}
        </span>
    </div>
    <div class="subscription-list" [ngClass]="{ isLoading: isLoading }">
        <div
            class="loading-spinner-wrapper d-flex flex-column"
            *ngIf="isLoading"
        >
            <div class="tryb-design-spinner"></div>
            <div class="spinner-text" *ngIf="isUpdatingSubscription">
                {{
                    'shared.components.subscriptionsPage.components.subscriptions.infoTexts.waitingForPaymentProvider'
                        | translate
                }}
            </div>
        </div>
        <div
            [ngClass]="{
                selected: subscriptionPlan.type === currentSubscriptionType,
                'next-selected':
                    subscriptionPlan.type === nextSubscriptionType &&
                    nextSubscriptionType !== currentSubscriptionType,
                'selected-when-free-plan':
                    subscriptionPlan.type === currentSubscriptionType ||
                    subscriptionPlan.type === nextSubscriptionType,
            }"
            class="subscription-element"
            *ngFor="let subscriptionPlan of subscriptionPlans"
        >
            <div class="subscription-card">
                <span class="subscription-type">{{
                    SUBSCRIPTION_META[subscriptionPlan.type].displayName
                }}</span>
                <div class="subscription-card-inner-wrapper">
                    <span class="subscription-price">
                        {{ subscriptionPlan.price }}
                        <span class="euro-char">€</span>
                        <span
                            class="star-char"
                            *ngIf="+subscriptionPlan.price !== 0"
                            >*</span
                        >
                    </span>
                    <span class="subscription-period">{{
                        'shared.components.subscriptionsPage.components.subscriptions.periods.' +
                            subscriptionPlan.period | translate
                    }}</span>
                    <ul class="subscription-description-list">
                        <li
                            *ngFor="
                                let descriptionKey of subscriptionPlan.descriptionKeys
                            "
                        >
                            <span>
                                {{
                                    'shared.components.subscriptionsPage.components.subscriptions.descriptions.basic.' +
                                        descriptionKey | translate
                                }}
                            </span>
                        </li>
                        <li>
                            <span>
                                {{
                                    'shared.components.subscriptionsPage.components.subscriptions.descriptions.typeSpecific.' +
                                        SUBSCRIPTION_META[subscriptionPlan.type]
                                            .translationKey | translate
                                }}
                            </span>
                        </li>
                        <li *ngIf="activeOrganization">
                            <span>
                                {{
                                    ('shared.components.subscriptionsPage.components.subscriptions.descriptions.typeSpecific.seats'
                                        | translate) +
                                        SEATS[subscriptionPlan.type]
                                }}
                            </span>
                        </li>
                    </ul>
                    <span class="subscription-credits-amount">
                        <strong>{{
                            subscriptionPlan.inclusiveCreditsAmount + ' Credits'
                        }}</strong>
                        {{
                            'shared.components.subscriptionsPage.components.subscriptions.credits.inclusive'
                                | translate
                        }}
                    </span>
                </div>
                <span
                    class="active-plan-info-text"
                    *ngIf="subscriptionPlan.type === currentSubscriptionType"
                >
                    {{
                        'shared.components.subscriptionsPage.components.subscriptions.infoTexts.activePlan'
                            | translate
                    }}
                </span>
                <span
                    class="active-plan-info-text"
                    *ngIf="
                        subscriptionPlan.type === nextSubscriptionType &&
                        nextSubscriptionType !== currentSubscriptionType
                    "
                >
                    {{
                        'shared.components.subscriptionsPage.components.subscriptions.infoTexts.nextPlan'
                            | translate
                                : {
                                      date:
                                          (currentSubscriptionEndDate
                                          | localizedDate: 'shortDate'),
                                  }
                    }}
                </span>
            </div>
            <button
                class="subscription-select-button"
                *ngIf="
                    (subscriptionPlan.type !== currentSubscriptionType ||
                        (nextSubscriptionType !== null &&
                            nextSubscriptionType !== undefined)) &&
                    subscriptionPlan.type !== nextSubscriptionType &&
                    !showTimeLimitedSubscriptionDialog
                "
                (click)="onChooseSubscription(subscriptionPlan.type)"
                [tabindex]="
                    (subscriptionPlan.type !== currentSubscriptionType ||
                        (nextSubscriptionType !== null &&
                            nextSubscriptionType !== undefined)) &&
                    subscriptionPlan.type !== nextSubscriptionType &&
                    !showTimeLimitedSubscriptionDialog
                        ? 0
                        : -1
                "
            >
                <span>{{
                    'shared.components.subscriptionsPage.components.subscriptions.buttons.select'
                        | translate
                            : {
                                  type: SUBSCRIPTION_META[subscriptionPlan.type]
                                      .displayName,
                              }
                }}</span>
            </button>
        </div>
    </div>
    <div class="bottom-section-wrapper" [ngClass]="{ isLoading: isLoading }">
        <div class="help-info-wrapper">
            <a
                href="https://www.tryb.ai/credits"
                target="_blank"
                rel="noopener noreferrer"
            >
                <span class="credits-explanation">
                    <img
                        class="credits-symbol"
                        src="assets/svg/reusable-svg/credit-character.svg"
                        alt="credit-character"
                    />&nbsp;
                    <span>{{
                        'shared.components.subscriptionsPage.components.subscriptions.infoTexts.creditsExplanation'
                            | translate
                    }}</span>
                </span>
            </a>
            <span class="price-explanation">{{
                'shared.components.subscriptionsPage.components.subscriptions.infoTexts.priceExplanation'
                    | translate
            }}</span>
        </div>
        <div class="d-flex gap-4">
            <div
                class="button-wrapper-tryb-button"
                *ngIf="hasPaidPlan() && !showTimeLimitedSubscriptionDialog"
            >
                <button
                    class="button-tryb-button standard-tryb-button"
                    (click)="onNavigateToCustomerPortal()"
                    [disabled]="isCreatingCustomerPortalSession"
                >
                    {{
                        'shared.components.subscriptionsPage.components.subscriptions.buttons.changePlan'
                            | translate
                    }}
                </button>
            </div>
            <div
                class="button-wrapper-tryb-button"
                *ngIf="hasPaidPlan() && !showTimeLimitedSubscriptionDialog"
            >
                <button
                    *ngIf="nextSubscriptionType !== SUBSCRIPTION_TYPE.FREE"
                    class="button-tryb-button delete-tryb-button"
                    (click)="onCancelSubscription(true)"
                >
                    {{
                        'shared.components.subscriptionsPage.components.subscriptions.buttons.cancel'
                            | translate
                    }}
                </button>
                <button
                    *ngIf="nextSubscriptionType === SUBSCRIPTION_TYPE.FREE"
                    class="button-tryb-button standard-tryb-button"
                    (click)="onCancelSubscription(false)"
                >
                    {{
                        'shared.components.subscriptionsPage.components.subscriptions.buttons.reactivate'
                            | translate
                    }}
                </button>
            </div>
        </div>
    </div>
</div>
